import shuffle from "seneca-common/utils/functions/random/shuffle";

import { MultiSelectContent, MultiSelectContentSource } from "../types";

const MAX_CORRECT_ANSWERS = 3;
const MAX_INCORRECT_ANSWERS = 3;

export function generateMultiSelectContent(
  source: MultiSelectContentSource
): MultiSelectContent {
  const options = shuffle(source.options);

  const correctAnswers = options
    .filter(option => option.correct)
    .slice(0, MAX_CORRECT_ANSWERS);

  const incorrectAnswers = options
    .filter(option => !option.correct)
    .slice(0, MAX_INCORRECT_ANSWERS);

  const answers = [...correctAnswers, ...incorrectAnswers];

  return {
    ...source,
    options: shuffle(answers),
    numberOfCorrectAnswers: correctAnswers.length
  } as MultiSelectContent;
}
